import { oregrown } from './oregrown';
import { diemPortland } from './diem-portland';

const dispensaries = [oregrown, diemPortland];

export { dispensaries, oregrown, diemPortland };
